import { WithAnalytics } from 'analytics/components'
import { NavLink } from 'react-router-dom'

export const NavigationItem = ({ tab }) => {
  if (tab.hide) return null
  if (!tab.disabled) {
    return (
      <NavLink id={`${tab.id}-link`} activeClassName="active" to={tab.path}>
        <WithAnalytics eventType={tab.analyticsEventType} expectedEventType="BIEvent">
          <span className="title-text">{tab.title}</span>
        </WithAnalytics>
      </NavLink>
    )
  }
  return (
    <a id={`${tab.id}-link`} className="disabled">
      <span className="title-text">{tab.title}</span>
    </a>
  )
}
